// src/components/portfolio/add-asset/components/SearchInput.js
import React from 'react';
import { Search, Loader2 } from 'lucide-react';

const SearchInput = ({ value, onChange, isLoading, mode }) => {
  const getPlaceholder = () => {
    switch (mode) {
      case 'fund':
        return 'Fon kodu veya adı ile ara...';
      case 'local':
        return 'BIST hisse senedi ara...';
      case 'currency':
        return 'Para birimi ara...';
      case 'api':
        return 'Global hisse/ETF ara...';
      default:
        return 'Ara...';
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={getPlaceholder()}
        className="w-full px-4 py-2 pl-10 bg-white dark:bg-gray-800 border dark:border-gray-700 
                   rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {isLoading ? (
          <Loader2 className="h-4 w-4 text-gray-400 animate-spin" />
        ) : (
          <Search className="h-4 w-4 text-gray-400" />
        )}
      </div>
    </div>
  );
};

export default SearchInput;